import React, { useEffect, useRef } from 'react';

import {
  Accordion,
  makeStyles,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Container,
  Backdrop,
} from '@material-ui/core';

import useCounter from '../../../hooks/Couters';
import useWindowDimensions from '../../../hooks/windowDimensions';
import { hasAnyRole, ROLE } from '../../../utils/permissions';
import MaterialChevronRightIcon from '../../core/MaterialIcons/MaterialChevronRightIcon';
import VideoTutorial from '../../VideoTutorial/VideoTutorial';
import './Accordion.css';

const useStyles = makeStyles((theme, a) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    top: '49px',
    right: '0px',
    background: '#FFFFFF',
    padding: '8px',
    gap: '8px',
    overflow: 'auto',
    letterSpacing: '-0.01em',
  },

  accordionSummary: {
    flexDirection: 'row-reverse!important',
    padding: '0px',
    width: '100%',
  },

  heading: {
    fontSize: theme.typography.pxToRem(16),
    lineHeight: theme.typography.pxToRem(20),
    fontWeight: theme.typography.fontWeightRegular,
  },
  gutters: {
    fontWeight: theme.typography.fontWeightRegular,
  },
}));

const AccordionHelp = (props) => {
  const { demandHelpViewCounter, transactionHelpViewCounter, uploadFileHelpViewCounter } =
    useCounter();
  const classes = useStyles();
  const { width, height } = useWindowDimensions();
  const [temp, setTemp] = React.useState(1);
  const [demandTemp, setDemandTemp] = React.useState(1);
  const [transactionTemp, setTransactionTemp] = React.useState(1);
  const accordionRef = useRef(null);

  useEffect(() => {
    if (accordionRef.current !== null) {
      accordionRef.current.style.maxHeight = height - 150;
    }
  }, [height]);

  const isButtonIsHidden = hasAnyRole([ROLE.CLIENT, ROLE.ADVANCED_PROVIDER]);

  return (
    <div ref={accordionRef} className={classes.root}>
      {!isButtonIsHidden && (
        <Accordion>
          <AccordionSummary
            expandIcon={<MaterialChevronRightIcon />}
            aria-controls="panel3a-content"
            id="panel3a-header"
            className={classes.accordionSummary}
          >
            <Typography className={classes.heading}>Request Survey</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Container>
              <VideoTutorial
                url="https://scribehow.com/embed/Cbre_Workflow__Rq2sEzg9RHqTu4u60GhFrA?skipIntro=true"
                width={width / 2}
                height={height - 268}
              ></VideoTutorial>
            </Container>
          </AccordionDetails>
        </Accordion>
      )}
      <Accordion>
        <AccordionSummary
          expandIcon={<MaterialChevronRightIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
          className={classes.accordionSummary}
        >
          <Typography className={classes.heading}>Analytics Dashboard</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Container>
            <VideoTutorial
              url="https://scribehow.com/embed/Cbre_Workflow__BNqL5GQ_TPyhCEUsgFpilA"
              width={width / 2}
              height={height - 268}
            ></VideoTutorial>
          </Container>
        </AccordionDetails>
      </Accordion>
    </div>
  );
};

export default AccordionHelp;
